export const checkValidPassword = (password, passwordConfirm) => {
  if (
    password &&
    passwordConfirm &&
    password.length >= 8 &&
    password === passwordConfirm
  ) {
    return true;
  } else {
    return false;
  }
};

export const checkSamePassword = (password, passwordConfirm) => {
  if (!password || !passwordConfirm) {
    return true;
  }
  if (password === passwordConfirm) {
    return true;
  } else {
    return false;
  }
};

export const checkMinimumLength = (password) => {
  if (!password) {
    return true;
  }
  return password.length >= 8;
};
